let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("62I9B")]).then(() => parcelRequire('fgD68'));